// extracted by mini-css-extract-plugin
module.exports = {"liningBackground":"Slider-module--liningBackground--20llG","carouselImg":"Slider-module--carouselImg--3aEov","carouselBox":"Slider-module--carouselBox--1RM3G"};